import React from 'react';
import classNames from 'classnames';
import { ProfileDataType, ProfileField } from '../../../types/profile';
import { profileDataTypeIcons, socialTypeIcons } from '../../../utils/iconUtils';
import { profileFieldToString } from '../../../utils/stringUtils';

interface FieldProps {
  field: ProfileField;
  handleClick?: (active: boolean, field: ProfileField) => void;
  active?: boolean;
}

export default function Field({ field, handleClick, active = false }: FieldProps): JSX.Element {
  return (
    <div
      key={field.id!}
      onClick={() => handleClick?.(active, field)}
      className={classNames(
        'flex w-full cursor-pointer items-center justify-between rounded-lg border bg-secondary px-3 py-2',
        {
          'bg-secondary-200': active,
        },
      )}>
      <div className="flex items-center gap-3">
        <div
          className={classNames('flex items-center justify-center rounded-lg bg-secondary-200 p-1 text-primary', {
            'bg-secondary-50': active,
          })}>
          {field.dataType === ProfileDataType.SOCIAL && field.social
            ? socialTypeIcons[field.social?.socialType]
            : profileDataTypeIcons[field.dataType as keyof typeof profileDataTypeIcons]}
        </div>
        <label className="text-sm font-medium text-primary-900">
          {field.dataType === ProfileDataType.SOCIAL
            ? field.social?.link
            : profileFieldToString(field)
                .split('\n')
                .map((x, idx) => <p key={idx}>{x}</p>)}
        </label>
      </div>
      {handleClick && (
        <div className="flex h-8 w-8 items-center justify-center">
          <input type="checkbox" className="!border !border-primary" checked={active} />
        </div>
      )}
    </div>
  );
}
